import { cn } from '@/lib/utils';
import { payButtonClass } from '@/components/features/Deposit/paymentFormClasses';
import failIcon from '@/assets/x.svg';

interface Props {
  /** Open the KYC / identity gate so the user can validate their details. */
  onValidate: () => void;
}

/**
 * Bottom-sheet content for a failed withdrawal request. Per Figma the copy is
 * fixed (field-level reasons stay inline on the form); the primary CTA routes
 * the user to the identity gate to re-validate their details, with a support
 * email as the fallback.
 */
export function WithdrawFail({ onValidate }: Props) {
  return (
    <div className="flex flex-col items-center text-center" role="status" aria-live="polite">
      <h2 className="text-[27px] font-semibold leading-normal text-ink">Withdraw Issue</h2>
      <img src={failIcon} alt="" aria-hidden className="my-[10px] h-[100px] w-auto motion-safe:animate-deposit-pop" />
      <p className="max-w-[377px] text-[18px] leading-[24px] text-ink">
        There might be an error in your details. Please <span className="font-semibold text-purple">Validate</span> your
        billing address or contact support.
      </p>
      <button
        type="button"
        onClick={onValidate}
        className={cn(payButtonClass, 'mt-[15px] h-[50px] w-[270px] text-[21.6px] capitalize')}
      >
        Validate Details
      </button>
      <a
        href="mailto:support@sunfltd.com"
        className="mt-3 text-[21.6px] leading-[34px] text-purple underline transition-opacity hover:opacity-80"
      >
        Contact Support
      </a>
    </div>
  );
}
